<template>
  
  <div class="py-4 container-fluid">
    <div class="card shadow-lg  card-profile-top mb-3">
        <div class="card shadow-lg">
          <div class="card-body p-3">
            <div class="row gx-4">
              <div class="col-auto">

              </div>
              <div class="col-auto my-auto">

              </div>
              <div class="col-auto">
                <div class="tags-container">
                      <span 
                        v-for="(tag, index) in monitoramento.operacoes" 
                        :key="index" 
                        class="tag"
                      >
                        {{ tag }}
                        <button @click="removeOperacao(monitoramento, tag)" class="remove-btn">&times;</button>
                      </span>
                      <input
                        type="numeric"
                        v-model="monitoramento.textTag"
                        @keydown.enter.prevent="addOperacao(monitoramento)"
                        placeholder="Digite a operação"
                        class="tag-input"
                      />
                      <span class="tag-erro" v-if="monitoramento.error_operacao"> {{ monitoramento.error_operacao  }}</span>
                      
                      <span class="tag-erro" v-if=" monitoramento.error"> {{ monitoramento.error  }}</span>
                      <span class="tag-erro" v-if=" monitoramento.loading"> 
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </span>
                </div>
              </div>                
            <div class="mx-auto mt-3 col-lg-7 col-md-7 col-sm-7  my-sm-auto ms-sm-auto me-sm-0">
              <div class="nav-wrapper position-relative end-0">
                <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">


                  <li class="nav-item my-auto">
                    
                    <label for="start-date">Data inicial:</label>
                    <input type="date" v-model="monitoramento.data_inicial" id="start-date" name="start-date">
                  

                  </li>
                  <li class="nav-item my-auto">

                    <label for="end-date">Data final:</label>
                    <input type="date" v-model="monitoramento.data_final" id="end-date" name="end-date">

                  </li>
                  <li class="nav-item my-auto">

                    

                      <argon-button
                          @click="pesquisarRotas()"
                          variant="gradient"
                          color="success"
                          fullWidth
                          size="lg">
                          Pesquisar
                      </argon-button>

                  </li>
                </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>


    <div class=" row">
      <div class="col-12">
        <monitoramento-table :rotas="rotas" />
        <loading  v-if="isLoading" />
      </div>
    </div>
  </div>
</template>
<style>
   .custom-marker {
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      text-align: center;
      border: 2px solid black;
      width: 50px;
      height: 50px;
    }

    .custom-marker img {
      width: 100%;
      border-radius: 50%;
    }
</style>
<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { defineComponent, ref } from 'vue';

import MonitoramentoTable from "./components/MonitoramentoTable.vue";
import Loading from "./components/Loading.vue";


import ArgonButton from "@/components/ArgonButton.vue";

import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    MonitoramentoTable,
    ArgonButton,
    Loading
  },
  data() {
    return {
      map: null,
      google: null,
      rotas: [],
      monitoramento: {data_inicial:"", data_final:"", operacoes:[]},
      current_page:0,
      total_pages:0,
      isLoading:true
    };
  },
  async mounted() {
    
    this.getRotas()

  },
  methods: {
   
    removeOperacao(pedido, tag) {

      if (!pedido.operacoes) pedido.operacoes = [];
      pedido.operacoes = pedido.operacoes.filter(t => t !== tag);

     },
    addOperacao(pedido) {
        this.monitoramento.error_operacao=null;
        fintailapi
        .get(`/operacoes/${pedido.textTag}`)
        .then((response) => {

            if(!pedido.operacoes)pedido.operacoes = [];
            if (pedido.textTag.trim() !== "" && !pedido.operacoes.includes(pedido.textTag)) {
              pedido.operacoes.push( pedido.textTag.trim() );
              pedido.textTag = "";
            }
        
        })
        .catch((error) => {
            this.monitoramento.error_operacao=`Operação ${pedido.textTag} não Localizada`;
        })

     },

    getRota(id) {

      fintailapi
      .get(`/rotas/${id}`)
      .then((response) => {

          const colors = ['#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF']; // Exemplo de cores

          this.current_page = 0;

          let rota = response.data;
          this.total_pages = response.data.count / 10

          const { Polyline, Marker } = this.google.maps;

          const decodedPoints = rota.rota.Caminho.flatMap(segment => [
            { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
            { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
          ]);

          const routePath = new Polyline({
            path: decodedPoints,
            geodesic: true,
            strokeColor: colors[0],
            strokeOpacity: 0.4,
            strokeWeight: 8,
          });

          routePath.setMap(this.map);

          for(let pedido of rota.rota.Pedidos){

              const local = {
                  id: pedido.id_pedido,
                  position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
              };

              new Marker({
                position: local.position,
                marker: local,
                map: this.map,
                icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
              });

          }

          new Marker({
            position: { lat: rota.rota.Operacao.latitude, lng:  rota.rota.Operacao.longitude},
            map:  this.map,
            title: "Centro",
            icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' // Ícone do marcador
          });


      })
      .catch((error) => {

        //this.isOpenRef = true;

      })

    },
    getRotas() {

        fintailapi
        .get(`/rotas`)
        .then(async(response) => {

            this.isLoading=false

            this.current_page = 0;

            this.rotas = response.data;
            this.total_pages = response.data.count / 10

            const colors = [
              '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
              '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
              '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
              '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
              '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
              '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
              '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
            ];
            
            let key = 0;

            for(let rota of this.rotas){

              this.rotas[key].color = colors[key % colors.length]

              this.rotas[key].distance = (rota.Caminho.reduce((acc, item) => acc + item.distance, 0)).toFixed(2);

               key++
            }


        })
        .catch((error) => {
          console.log(error)
          //this.isOpenRef = true;

        })

    },

    pesquisarRotas() {

        fintailapi
        .post(`/rotas/pesquisar`, this.monitoramento)
        .then(async(response) => {

            this.isLoading=false

            this.current_page = 0;

            this.rotas = response.data;
            this.total_pages = response.data.count / 10

            const colors = [
              '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
              '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
              '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
              '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
              '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
              '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
              '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
            ];
            
            let key = 0;

            for(let rota of this.rotas){

              this.rotas[key].color = colors[key % colors.length]

              this.rotas[key].distance = (rota.Caminho.reduce((acc, item) => acc + item.distance, 0)).toFixed(2);

               key++
            }


        })
        .catch((error) => {
          
          console.log(error)

        })

    },

  },
  created() {

  },

});


</script>
